module.exports = __webpack_public_path__ + "img/logo.01ba5c9e.png";